function PlaylistChapterPicker({ chapters, activeChapterId, onChapterChange }) {
  return (
    <section className="mt-10">
      <h2 className="text-lg font-bold text-[#1B1B1B]">Choose chapters</h2>
      <div className="mt-4 flex flex-wrap gap-3">
        {chapters.map((chapter) => {
          const isActive = chapter.id === activeChapterId;
          return (
            <button
              key={chapter.id}
              type="button"
              onClick={() => onChapterChange?.(chapter.id)}
              className={`rounded-xl px-5 py-3 text-sm font-semibold transition sm:text-base ${
                isActive
                  ? 'bg-[#9369CC] text-white shadow-md'
                  : 'border border-[#9369CC] bg-white text-[#9369CC] hover:bg-[#F8F4FF]'
              }`}
            >
              {chapter.label}
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default PlaylistChapterPicker;
